import React, { ForwardedRef, forwardRef, useCallback } from 'react'

import { Editable } from 'slate-react'
import { EditableProps } from 'slate-react/dist/components/editable'

import { bemJoin } from '@app/lib/bem'
import { Element } from '@app/lib/inputs/RichEditor/editor/Element'
import { Leaf } from '@app/lib/inputs/RichEditor/editor/Leaf'

import './EditableArea.scss'

const b = bemJoin('editor-editable')

export const EditableArea = forwardRef(
  (props: Partial<EditableProps>, ref: ForwardedRef<HTMLDivElement>) => {
    const renderElement = useCallback((props) => <Element {...props} />, [])
    const renderLeaf = useCallback((props) => <Leaf {...props} />, [])

    return (
      <div ref={ref}>
        <Editable
          {...props}
          className={b()}
          renderElement={renderElement}
          renderLeaf={renderLeaf}
          placeholder={''}
          spellCheck
        />
      </div>
    )
  }
)
